import { render, staticRenderFns } from "./PopupClinicList.vue?vue&type=template&id=0372f582&scoped=true&"
import script from "./PopupClinicList.vue?vue&type=script&lang=ts&"
export * from "./PopupClinicList.vue?vue&type=script&lang=ts&"
import style0 from "./PopupClinicList.vue?vue&type=style&index=0&id=0372f582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0372f582",
  null
  
)

export default component.exports